<template>
  <div>
    <van-sticky>
      <van-nav-bar :border="false" >
        <template #title>
          <strong>提现功能</strong>
        </template>
        <template #left>
          <span class="iconfont icon-houtui fs-24 fw-700" @click="$router.replace('/me')"></span>
        </template>
      </van-nav-bar>
    </van-sticky>
    <div class="mr-card">
      <p class="text-center color-6D788E fs-14">可提现金额</p>
      <h1 class="text-center fs-36">{{ userAccountInfo.balance }}</h1>
      <van-divider />
      <p class="color-6D788E fs-12 pl-15">累计已提现金额 <strong class="color-0D0E15 ml-5">{{ userAccountInfo.total_case_out }}</strong></p>
      <div class="flex justify-between pl-15 pr-15 mt-15">
        <van-button color="#FC3159" class="btn" to="/withdraw/to-card">提现</van-button>
        <van-button class="btn" to="/withdraw/withdraw-record">提现记录</van-button>
      </div>
    </div>
    <div class="rule">
      <h2 class="fs-14">提现规则</h2>
      <ul>
        <li v-for="txt in rules" :key="txt">{{ txt }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Withdraw',
  computed: {
    rules() {
      return ['提现金额最少不能低于100元人民币,每月仅限提现一次；', '每月1至5日为申请提现日，每月6至15日为转账日；', '申请提现后，一般情况每月10至15日为资金实际到账日。']
    },
    ...mapState(['userAccountInfo'])
  },
  async mounted(){
    await this.$store.dispatch('getUserInfo')
  },
}
</script>

<style lang="scss" scoped>
.mr-card{
  padding: 25px 0;
  margin: 15px;
  border-radius: 16px;
  box-shadow: 0 0 6px 0#D8D8D8;
  background-color: #fff;
  .btn{
    width: 50%;
    border-radius: 10px;
    &:first-child{
      margin-right: 15px;
    }
  }
}
.rule{
  padding-left: 15px;
  li{
    font-size: 12px;
    color: #6D788E;
    line-height: 25px;
    &::before{
      content: "";
      width: 5px;
      height: 5px;
      display: inline-block;
      background-color: currentColor;
      border-radius: 50%;
      margin-right: 5px;
      margin-top: -3px;
      vertical-align: middle;
    }
  }
}
</style>
